export const APP_IDENTITY = {
  name: 'AI Commerce Ready',
  legalEntity: 'AIthentic LLC',
  supportEmail: 'steven.wu@ai-commerce-ready.com',
} as const

export const LEGAL_ROUTES = {
  privacy: '/legal/privacy',
  terms: '/legal/terms',
} as const

/** The only install destination on the public site. The blog header uses the same URL. */
export const SHOPIFY_APP_STORE_URL = 'https://apps.shopify.com/ai-commerce-ready' as const
